module.exports = __webpack_public_path__ + "img/34.42028190.png";